import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ScrollToService } from 'ng2-scroll-to-el';
import { SugarService } from '../model/sugar.service';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';
var PaginatorComponent = /** @class */ (function () {
    function PaginatorComponent(sugarService, scrollService) {
        this.sugarService = sugarService;
        this.scrollService = scrollService;
        this.allPages = 0;
        this.currentPage = 1;
        this.prevPage = 0;
        this.pages = [];
        this.list = [];
        this.pageChange = new EventEmitter();
        this.pageChanged = new EventEmitter();
        this.changed = false;
        this.maxPage = 0;
    }
    PaginatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sugarSub = this.sugarService.getData().subscribe(function (data) {
            if (data.collectionId === _this.collection) {
                _this.handleCollection(data);
            }
        });
        this.handleCollection(this.sugarService.getCollectionContents(this.collection));
    };
    PaginatorComponent.prototype.ngOnDestroy = function () {
        if (this.sugarSub) {
            this.sugarSub.unsubscribe();
        }
    };
    PaginatorComponent.prototype.changePage = function (page) {
        if (page === '...') {
            return;
        }
        if (page > 0 && page <= this.allPages && page !== this.currentPage) {
            this.prevPage = this.currentPage;
            this.changed = true;
            page = typeof page === 'string' ? parseInt(page, 10) : page;
            this.sugarService.changePage(this.collection, page);
            this.pageChange.emit({
                previous: this.prevPage,
                current: page,
            });
            this.scrollService.scrollTo('#top', 600);
        }
    };
    PaginatorComponent.prototype.build = function () {
        var pagination = [];
        var len = (this.pages || []).length;
        var currentPage = this.currentPage;
        var first = currentPage === 1 ? false : 1;
        var last = currentPage === len ? false : len;
        var before;
        var after;
        if (currentPage <= 2) {
            before = false;
        }
        else if (currentPage === 3) {
            before = [2];
        }
        else {
            before = currentPage === 4 ? [2, 3] : ['...', (currentPage - 1)];
        }
        if (currentPage >= (len - 1)) {
            after = false;
        }
        else if ((currentPage + 1) === (len - 1)) {
            after = [(currentPage + 1)];
        }
        else {
            after = (currentPage + 2) === (len - 1) ? [(currentPage + 1), (currentPage + 2)] : [(currentPage + 1), '...'];
        }
        if (first) {
            pagination.push(first);
        }
        if (before) {
            pagination = pagination.concat(before);
        }
        pagination.push(currentPage);
        if (after) {
            pagination = pagination.concat(after);
        }
        if (last) {
            pagination.push(last);
        }
        this.maxPage = len;
        this.list = pagination;
    };
    PaginatorComponent.prototype.handleCollection = function (data) {
        if (!data) {
            return;
        }
        this.allPages = data.pagination.all;
        this.pages = [];
        this.currentPage = parseInt(data.pagination.current, 10);
        this.pages = data.pagination.pages;
        if (this.changed) {
            this.pageChange.emit({
                previous: this.prevPage,
                current: this.currentPage,
            });
        }
        this.build();
    };
    PaginatorComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [SugarService,
            ScrollToService])
    ], PaginatorComponent);
    return PaginatorComponent;
}());
export { PaginatorComponent };
